import React from "react";
import {motion} from "framer-motion";
import {twMerge} from "tailwind-merge";
import Typo from "../../../typo";

const RedCrossIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="45"
        height="45"
        viewBox="0 0 256 256"
        xmlSpace="preserve"
        className={'mx-2'}
        {...props}
    >
        <g
            style={{
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1,
            }}
            transform="translate(1.4066 1.4066) scale(2.81 2.81)"
        >
            <path
                d="M28.5 65.5c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l33-33c1.561-1.562 4.096-1.562 5.656 0 1.563 1.563 1.563 4.095 0 5.657l-33 33c-.78.781-1.803 1.172-2.827 1.172z"
                style={{
                    stroke: "none",
                    strokeWidth: 1,
                    strokeDasharray: "none",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 10,
                    fill: "rgb(236,0,0)",
                    fillRule: "nonzero",
                    opacity: 1,
                }}
                strokeLinecap="round"
            />
            <path
                d="M61.5 65.5c-1.023 0-2.048-.391-2.828-1.172l-33-33c-1.562-1.563-1.562-4.095 0-5.657 1.563-1.562 4.095-1.562 5.657 0l33 33c1.563 1.562 1.563 4.095 0 5.656-.78.782-1.805 1.173-2.829 1.173z"
                style={{
                    stroke: "none",
                    strokeWidth: 1,
                    strokeDasharray: "none",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 10,
                    fill: "rgb(236,0,0)",
                    fillRule: "nonzero",
                    opacity: 1,
                }}
                strokeLinecap="round"
            />
            <path
                d="M45 90C20.187 90 0 69.813 0 45S20.187 0 45 0s45 20.187 45 45S69.813 90 45 90zM45 8C24.598 8 8 24.598 8 45s16.598 37 37 37 37-16.598 37-37S65.402 8 45 8z"
                style={{
                    stroke: "none",
                    strokeWidth: 1,
                    strokeDasharray: "none",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 10,
                    fill: "rgb(236,0,0)",
                    fillRule: "nonzero",
                    opacity: 1,
                }}
                strokeLinecap="round"
            />
        </g>
    </svg>
);
const QuizViewOption = ({id, active, onClick, option, trueAnswers, showTrueAnswer = true}) => {
    let successCheck = <></>;
    let errorCheck = <></>;
    if (showTrueAnswer){
        if (active && trueAnswers.includes(id)) {
            successCheck = <>
            <span className={'w-8 h-8 mx-2 pt-1'}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enableBackground="new 0 0 64 64">
            <path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50
	l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047"/></svg>
            </span>
            </>;
        }


        if (active && !trueAnswers.includes(id)) {
            errorCheck = <><RedCrossIcon /></>;
        }
    }


    return (
        <div className="flex items-center" onClick={() => onClick(id)}>
            <div className="w-fit rounded-full bg-purple-1 p-0.5">
                <div className="rounded-full bg-purple-5 p-1">
                    <motion.div
                        transition={{duration: 0.3}}
                        animate={{scale: active ? [0, 1.5, 1] : [1, 0]}}
                        className={"h-3 w-3 rounded-full bg-purple-1"}
                    />
                </div>
            </div>
            <div className="w-3">
                <motion.div animate={{width: active ? "0.75rem" : "0rem"}} className="h-1 bg-purple-1"/>
            </div>

            <Typo
                className={twMerge(
                    "w-full  rounded-xl border p-1.5 px-4 transition-all md:p-3",
                    active ? "border-purple-1" : "border-purple-4"
                )}
                size="sm"
                type={active ? "primary" : "secondary"}
            >
                {option}
            </Typo>
            {successCheck}
            {errorCheck}
        </div>
    );
};

export default QuizViewOption;
